// Chronomètre discret d'une phase (R-SES-04) : indicatif, sans alerte, on peut dépasser.
import { useEffect, useState } from 'react';

export function Chrono({ depuis, cibleMin }: { depuis?: number; cibleMin: number }) {
  const [, tic] = useState(0);
  useEffect(() => {
    if (!depuis) return;
    const t = window.setInterval(() => tic((n) => n + 1), 1000);
    return () => window.clearInterval(t);
  }, [depuis]);
  if (!depuis) return <span className="chrono">{cibleMin} min</span>;
  const s = Math.floor((Date.now() - depuis) / 1000);
  const mm = String(Math.floor(s / 60)).padStart(2, '0');
  const ss = String(s % 60).padStart(2, '0');
  return <span className="chrono" title={`objectif : ${cibleMin} min`}>{mm}:{ss} / {cibleMin} min</span>;
}
